import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { ApiService } from 'services';
import { addSupportingDoc, deleteSupportingDoc, fileUploadError } from 'actions';
import { getStorageSetting } from 'common/storage';

import FileUpload from 'components/Common/FileUpload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class SupportingDocuments extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    formId: PropTypes.number.isRequired,
    documents: PropTypes.arrayOf(PropTypes.shape({}))
  }

  static defaultProps = {
    documents: [],
  };

  constructor(props) {
    super(props);

    const files = getStorageSetting('files') || [];

    this.state = {
      supportingDocType: '',
      files
    };
  }

  static onViewSupportingDocument(file) {
    if (file) {
      window.open(`customers/supporting-docs/${ file.id }`, '_blank'); // to open new page
    }
  }

  onFileUploadCancel(file) {
    const { dispatch } = this.props;
    const error = {
      code: 400,
      message: `Upload of ${ file.name } has been canceled.`
    };
    dispatch(fileUploadError(error));
  }

  onFileUploadError(file, error) {
    const { dispatch } = this.props;
    error.message = `Upload of ${ file.name } has been canceled.  ${ error.message }`;
    dispatch(fileUploadError(error));
  }

  onFileUploadSuccess(file, response) {
    const { dispatch } = this.props;
    dispatch(addSupportingDoc(response));
  }

  onDeleteSupportingDocument(file) {
    const { dispatch } = this.props;
    dispatch(deleteSupportingDoc(file.id));
  }

  groupDocuments = () => {
    const { documents } = this.props;
    const map = new Map();

    if (documents != null) {
      documents.forEach((doc) => {
        if (doc != null) {
          const key = doc.typeDescription;
          const collection = map.get(key);
          if (collection == null) {
            map.set(key, [doc]);
          } else {
            collection.push(doc);
          }
        }
      });
    }

    return Array.from(map);
  }

  handleChange(event) {
    this.setState({ supportingDocType: event.target.value });
  }

  render() {
    const { files, supportingDocType } = this.state;
    const { documents, formId } = this.props;

    const displayDocs = documents && documents.sort((a, b) => {
      const lines = Math.ceil(a.typeDescription.length / 28) + Math.ceil((a.originalFileName || a.fileName).length / 28)
        - (Math.ceil(b.typeDescription.length / 28) + Math.ceil((b.originalFileName || b.fileName).length / 28));

      if (lines === 0) {
        if (a.typeDescription === b.typeDescription) {
          return (a.originalFileName || a.fileName) > (b.originalFileName || b.fileName) ? 1 : -1;
        }

        return a.typeDescription > b.typeDescription ? 1 : -1;
      }

      return lines > 0 ? 1 : -1;
    });

    return <div id="supporting-documents" className="supporting-documents">
      <div className="row">
        <div className="col">
          <p className="mb-2">Please select which type of document you would like to upload</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <select value={ supportingDocType } onChange={ e => this.handleChange(e) } aria-label="Supporting Document Type">
            <option value="" disabled>Choose a document type</option>
            <option value="affidavitstatingnotprivatefoundation">Affidavit Stating Not Private Foundation</option>
            <option value="armedforcesidcard">Armed Forces ID Card</option>
            <option value="articleassoc">Articles of Association</option>
            <option value="articleincorp">Articles of Incorporation</option>
            <option value="auditorsletter">Auditor&apos;s Letter</option>
            <option value="bankidcard">Bank ID Card</option>
            <option value="cedula">Cedula</option>
            <option value="certincorp">Certificate of Incorporation</option>
            <option value="certltdpartner">Certificate of Limited Partnership</option>
            <option value="certlossnationality">Certificate of Loss of Nationality</option>
            <option value="certpartnership">Certificate of Partnership</option>
            <option value="certreg">Certificate of Registration</option>
            <option value="certofresidence">Certificate of Residence</option>
            <option value="controllingpersonselfcertification">Controlling Person Self-Certification</option>
            <option value="dateofbirthsupportingdoc">Date of Birth Supporting Doc</option>
            <option value="drivinglicence">Driver’s License</option>
            <option value="form8832">Form 8832</option>
            <option value="irsdeterminationletter">IRS Determination Letter</option>
            <option value="liquidationandbankruptcy">Liquidation and Bankruptcy</option>
            <option value="memorandum">Memorandum of Association</option>
            <option value="nationalidcard">National ID Card</option>
            <option value="opinionfromuscounsel">Opinion From U.S. Counsel</option>
            <option value="othergovid">Other Government ID</option>
            <option value="ownerreportingstatement">Owner Reporting Statement</option>
            <option value="partnership">Partnership Agreement</option>
            <option value="passport">Passport</option>
            <option value="permitofresidence">Permit of Residence</option>
            <option value="powerofattorney">Power Of Attorney</option>
            <option value="qdddocumentation">QDD Documentation</option>
            <option value="qslstatement">QSL Statement</option>
            <option value="writtenexplanation">Reasonable Written Explanation</option>
            <option value="regcert">Registration Certificate</option>
            <option value="taxpayercert">Taxpayer Certificate</option>
            <option value="tinnotissued">Tin Not Issued</option>
            <option value="trustagreement">Trust Agreement</option>
            <option value="trustdeed">Trust Deed</option>
            <option value="trusteedocumentedtrustletter">Trustee Documented Trust Letter</option>
            <option value="votercard">Voter Registration Card</option>
            <option value="will">Will</option>
            <option value="notlisted">Other document type not listed above</option>
          </select>
        </div>
        <div className="col-12 mv-1">
          <FileUpload
            postUrl={ ApiService.getFileUploadUrl() }
            acceptedFiles="application/pdf,.jpg,.png,.bmp,.msg,.doc,.docx,.jpeg,.tiff,.gif,.tif,.xls,.xlsx"
            maxFilesize={ files.maxFilesize }
            docCategory="supportingdocument"
            docType={ supportingDocType != null ? supportingDocType : '' }
            id={ formId }
            removeFileAfterUpload
            onFileUploadCancel={ file => this.onFileUploadCancel(file) }
            onFileUploadSuccess={ (file, response) => this.onFileUploadSuccess(file, response) }
            onFileUploadError={ (file, error) => this.onFileUploadError(file, error) }
          />
        </div>
      </div>
      <div className="row">
        { documents && documents.length > 0 && <div className="col-12">
          <h3 className="text-bold mb-2">Uploaded Documents</h3>
        </div> }
        { displayDocs && displayDocs.length > 0 && displayDocs.map(item => item && <div key={ item.id } className="col-12 col-md-6 mb-2">
          <div className="row file-content mh-0">
            <div className="col-10 ph-0">
              <p>{item.typeDescription}</p>
              <p className="break-word">{item.originalFileName || item.fileName}</p>
            </div>
            <div className="col-2 ph-0 aside text-right">
              <button onClick={ () => this.onDeleteSupportingDocument(item) } type="button" title="Delete Document">
                <span className="cross fa-layers fa-2x">
                  <FontAwesomeIcon icon="circle" className="fa-sm" />
                  <span className="fa-xs"><FontAwesomeIcon icon="trash-alt" className="layered-button fa-xs" /></span>
                </span>
              </button>
            </div>
          </div>
        </div>)}
      </div>
    </div>;
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapDispatchToProps
)(SupportingDocuments);
